import React from 'react';
import AppRoutes from '../routes';
import Footer from '../components/vcare/footer';
import Header from '../components/vcare/header';
import HomePage from '../pages/vcare/home_page';
import AboutPage from '../pages/vcare/about_page';
import ContactPage from '../pages/vcare/contact_page';

export default function VcareTemplate(props) {
    return (
        <React.Fragment>
            <Header />
            <AppRoutes
                homePage={HomePage}
                aboutPage={AboutPage}
                contactPage={ContactPage}
            />
            <Footer />
        </React.Fragment>
    )
}
